import React from 'react';
import PropTypes from 'prop-types';

import './NonBreakingHyphen.scss';

/**
 * This component wraps all words with a hyphen in a`<span style="white-space:nowrap" />`.
 * This prevents hyphens from being used as natural line breaks by the browser.
 *
 * The easier solution is to use non-breaking hyphen characters. Sadly the non-breaking
 * hyphens look different from normal hyphens ('‑' vs '-') in the font we use; they look like
 * an em-dash instead of a hyphen.
 */
const NonBreakingHyphen = ({ message }) => {
	const parts = message.split(/(?=\S*-)([\w-]+)/g);
	const children = [];

	for (let i = 0; i < parts.length; i++) {
		if (i % 2 === 0) {
			children.push(parts[i]);
		} else {
			children.push(
				<span className="nowrap" key={i}>
					{parts[i]}
				</span>
			);
		}
	}

	return children;
};

NonBreakingHyphen.propTypes = {
	message: PropTypes.string.isRequired,
};

export default NonBreakingHyphen;
